import { createSlice } from '@reduxjs/toolkit';
import { formatPhoneForServer } from '@shared/lib/phone';

const initialState = {
  patientUuid: null,
  patientInfo: null,
};

const activePatientSlice = createSlice({
  name: 'activePatient',
  initialState,
  reducers: {
    setPatientUuid: (state, action) => {
      state.patientUuid = action.payload;
    },
    setPatientInfo: (state, action) => {
      const patientInfo = action.payload;
      if (patientInfo) {
        const formattedPhone = formatPhoneForServer(patientInfo?.phone?.phone);
        state.patientInfo = {
          ...patientInfo,
          phone: { phone: formattedPhone },
        };
      } else {
        state.patientInfo = null;
      }
    },
    clearActivePatient: (state) => {
      state.patientUuid = null;
      state.patientInfo = null;
    },
  },
});

export const {
  setPatientUuid: setActivePatientUuid,
  setPatientInfo: setActivePatientInfo,
  clearActivePatient
} = activePatientSlice.actions;

export default activePatientSlice.reducer;
